export enum Queries {
    getInclusionScoresSkeleton = 'getInclusionScoresSkeleton',
}
